import { OwnershipType, OwnershipTypeEntity } from '../../../../../../../types.generated';

/**
 * A mapping from OwnershipType to it's display name & description. In the future,
 * we intend to make this configurable.
 */
export const OWNERSHIP_DISPLAY_TYPES = [
    {
        urn: 'urn:li:ownershipType:technicalOwner',
        type: OwnershipType.TechnicalOwner,
        info: {
            name: 'Technical Owner',
            description: 'Involved in the production, maintenance, or distribution of the asset(s).',
        },
    },
    {
        urn: 'urn:li:ownershipType:businessOwner',
        type: OwnershipType.BusinessOwner,
        info: {
            name: 'Business Owner',
            description: 'Principle stakeholders or domain experts associated with the asset(s).',
        },
    },
    {
        urn: 'urn:li:ownershipType:dataSteward',
        type: OwnershipType.DataSteward,
        info: {
            name: 'Data Steward',
            description: 'Involved in governance of the asset(s).',
        },
    },
    {
        urn: 'urn:li:ownershipType:other',
        type: OwnershipType.None,
        info: {
            name: 'None',
            description: 'No ownership type specified.',
        },
    },
];

const ownershipTypeToDetails = new Map();
OWNERSHIP_DISPLAY_TYPES.forEach((ownershipDetails) => {
    ownershipTypeToDetails.set(ownershipDetails.type, ownershipDetails);
});

export const getNameFromType = (type: OwnershipType) => {
    return ownershipTypeToDetails.get(type)?.info?.name || type;
};

export const getDescriptionFromType = (type: OwnershipType) => {
    return ownershipTypeToDetails.get(type)?.description || 'No description';
};

function formatOwnershipType(type: OwnershipType): string {
    return type
        .toString()
        .toLowerCase()
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

const OwnerShipTypeUrns = {
    TechnicalOwner: 'urn:li:ownershipType:__system__technical_owner',
    BusinessOwner: 'urn:li:ownershipType:__system__business_owner',
    DataSteward: 'urn:li:ownershipType:__system__data_steward',
    None: 'urn:li:ownershipType:__system__none',
};

function getFormattedOwnershipTypeNameFromURN(ownershipType?: OwnershipTypeEntity | null) {
    const ownershipTypeMap: Record<string, OwnershipType> = {
        [OwnerShipTypeUrns.TechnicalOwner]: OwnershipType.TechnicalOwner,
        [OwnerShipTypeUrns.BusinessOwner]: OwnershipType.BusinessOwner,
        [OwnerShipTypeUrns.DataSteward]: OwnershipType.DataSteward,
        [OwnerShipTypeUrns.None]: OwnershipType.None,
    };
    return formatOwnershipType(ownershipTypeMap[ownershipType?.urn ?? OwnerShipTypeUrns.None] || 'Other');
}

export function getOwnershipTypeName(ownershipType?: OwnershipTypeEntity | null) {
    if (ownershipType?.info?.name) {
        return ownershipType?.info?.name;
    }
    return getFormattedOwnershipTypeNameFromURN(ownershipType);
}
